import moment from 'moment';

export const today = moment().startOf('day');
